import * as XLSX from "xlsx";
import { toast } from "react-toastify";
const exportToExcel = (data, headers, fileName = "export") => {
  if (!data || data.length === 0) {
    toast("No data to export");
    return;
  }

  if (!headers || headers.length === 0) {
    toast("Headers missing");
    return;
  }

  // ✅ format data (NUMBER → TEXT here)
  const formattedData = data.map((item) => {
    const obj = {};
    headers.forEach((h) => {
      const value = item[h.key];

      obj[h.label] =
        value === null || value === undefined
          ? "-"
          : typeof value === "number"
          ? value.toString() // 👈 yahi main fix
          : value;
    });
    return obj;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // ✅ AUTO WIDTH BASED ON CONTENT
  worksheet["!cols"] = headers.map((h) => {
    const headerLength = h.label.length;

    const maxCellLength = formattedData.reduce((max, row) => {
      const val = row[h.label];
      return Math.max(max, val ? val.toString().length : 0);
    }, 0);

    return {
      wch: Math.max(headerLength, maxCellLength) + 4,
    };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default exportToExcel;
